import React from "react"
import CustomSelect from "../../../../ui/atoms/CustomSelect"
import { useCountries } from "../../hooks/country"

export interface CountryOption {
  label: string
  value: string
}

export interface CountryItem {
  code: string
  name: string
  hasProvince: boolean
}

export interface CountryAutocompleteProps {
  id?: string
  name?: string
  value?: string
  onCountryChange?: (value?: CountryItem) => void
  onCountryInit?: (value: CountryItem) => void
  onChange?: (value?: string) => void
  fullWidth?: boolean
  label?: React.ReactNode
  inputRef?: React.Ref<any>
  className?: string
}

const CountryAutocomplete = ({
  id,
  name,
  value,
  onChange,
  onCountryChange,
  onCountryInit,
  fullWidth,
  label,
  inputRef,
  className,
}: CountryAutocompleteProps) => {
  const { data } = useCountries()
  const values: CountryOption[] =
    data?.countries.values.map((x) => ({
      value: x.code,
      label: x.name,
    })) ?? []

  const getCountry = (countryCode: string) =>
    data?.countries.values.find(
      (x) => x.code.toLowerCase() === countryCode.toLowerCase()
    )

  const handleChange = (value?: string) => {
    onChange?.(value)
    onCountryChange?.(
      value ? getCountry(value) : undefined
      // data?.countries.values.find(
      //   (x) => x.code.toLowerCase() === value.toLowerCase()
      // )
    )
  }

  const defaultValue = data?.countries.default.code
  const currentValue = value ?? defaultValue ?? ""

  React.useEffect(() => {
    if (!value && defaultValue) {
      handleChange(defaultValue)
    }
  }, [value, defaultValue])

  React.useEffect(() => {
    if (!onCountryInit) {
      return
    }
    const item = getCountry(currentValue)
    if (item) {
      onCountryInit(item)
    }
  }, [data])

  return (
    <CustomSelect
      id={id}
      name={name}
      inputRef={inputRef}
      value={currentValue}
      values={values?.map((x) => ({
        id: x.value,
        label: x.label,
      }))}
      size="large"
      onChange={handleChange}
      fullWidth={fullWidth}
      label={label}
      className={className}
    />
    // <AutocompleteSelect
    //   value={currentValue}
    //   defaultOption={{ label: "Italia", value: "it" }}
    //   onChange={handleChange}
    //   options={values}
    //   autocomplete="off"
    //   disableClearable
    //   {...other}
    // />
  )
}

// CountryAutocomplete.defaultProps = {
//   ...CustomSelect.defaultProps,
// }

export default React.forwardRef((props: any, ref) => (
  <CountryAutocomplete {...props} inputRef={ref} />
))
